<template>
  <form @submit.prevent="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Conditions</p>
      </header>
      <section class="modal-card-body">
        <b-button @click="AddBlankCondition()" type="is-success" icon-right="plus">Add Condition</b-button>
        <b-field label="Condition Type" expanded v-if="conditions.length > 0">
          <b-select placeholder="Select a type" v-model="conditionType">
            <option v-for="conditionTypeOption in conditionTypes" :value="conditionTypeOption" :key="conditionTypeOption">{{ conditionTypeOption }}</option>
          </b-select>
        </b-field>
        <b-field v-for="(condition, index) in conditions" :key="'condition-' + index" grouped>
          <b-field label="Setting To Check" expanded>
            <b-select placeholder="Select a setting" v-model="condition.setting_id">
              <option v-for="setting in settings" :value="setting.settings_id" :key="setting.settings_id">{{ setting.settings_name }}</option>
            </b-select>
          </b-field>
          <b-field label="Operator">
            <b-select placeholder="Select an operator" v-model="condition.operator">
              <option v-for="operator in operators" :value="operator" :key="operator">
                {{ operator }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Value" expanded>
            <b-input type="text" v-model="condition.value"></b-input>
          </b-field>
          <b-field label="Actions">
            <b-button @click="RemoveCondition(index)" type="is-danger" icon-right="trash"> </b-button>
          </b-field>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" @click="$emit('submitted', { conditions: conditions, condition_type: conditionType }, setting)">Submit</button>
        <button class="button" type="button" @click="$parent.close()">Cancel</button>
      </footer>
    </div>
  </form>
</template>
  
<style scoped>
</style>
  
<script>
export default {
  props: {
    setting: {
      type: Object,
      required: true,
    },
    settings: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      conditions: [],
      conditionType: "AND",
      operators: ["=", "!=", ">", ">=", "<", "<="],
      conditionTypes: ["AND", "OR"],
    };
  },
  mounted() {
    if (this.setting.conditions) {
      this.conditions = this.setting.conditions.conditions;
      this.conditionType = this.setting.conditions.condition_type;
    }
  },
  methods: {
    AddBlankCondition() {
      this.conditions.push({
        setting_id: null,
        operator: "=",
        value: "",
      });
    },
    RemoveCondition(index) {
      this.conditions.splice(index, 1);
    },
  },
};
</script>
  